import { render, staticRenderFns } from "./ClueRemarks.vue?vue&type=template&id=5b97e2ca&scoped=true"
import script from "./ClueRemarks.vue?vue&type=script&lang=js"
export * from "./ClueRemarks.vue?vue&type=script&lang=js"
import style0 from "./ClueRemarks.vue?vue&type=style&index=0&id=5b97e2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97e2ca",
  null
  
)

export default component.exports